// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"13":"85ee2080","1896":"85ee2080","6419":"85ee2080","7395":"85ee2080","7502":"85ee2080","8801":"85ee2080"}[chunkId] + ".chunk.css";
};